import { Spin } from "antd";
import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InwardRegisterImg from "../../../../images/InwardRegister.png";
import DispatchMaterialImg from "../../../../images/DispatchMaterial.png";
import DispatchReportImg from "../../../../images/DispatchReport.png";
import PendingTestingImg from "../../../../images/PendingTesting.png";
import ProcessStatusImg from "../../../../images/ProcessStatus.png";
import ChatHistoryImg from "../../../../images/ChatHistory.png";
import CommunicationLogImg from "../../../../images/CommunicationLog.png";
import Calibration from "../../../../images/Calibration.png";
import LogBookImg from "../../../../images/books.png";

const Reports = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Reports</h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pb-0">
              {/* <div className="container-fluid"> */}
              <div className="row me-0">
                <div className="col-xl-2 pe-0">
                  <Link
                    to="/inward-register"
                    title="This report shows list of the Material Inwards "
                  >
                    <div className="card box-hover report-box">
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <img src={InwardRegisterImg} width="50" alt="" />
                          </div>
                          <div className="total-projects ms-3">
                            <h6>Inward Register </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-xl-2 pe-0">
                  <Link
                    to="/process-status"
                    title="This report shows TC No wise process wise status & Entry log"
                  >
                    <div className="card box-hover report-box">
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <img src={ProcessStatusImg} width="50" alt="" />
                          </div>
                          <div className="total-projects ms-3">
                            <h6>Process Status </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                {AuthUser?.Permissions?.DispatchReport == 1 && (
                  <div className="col-xl-2 pe-0">
                    <Link
                      to="/dispatch-report"
                      title="This report shows list of the Dispatched Reports"
                    >
                      <div className="card box-hover report-box">
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={DispatchReportImg} width="50" alt="" />
                            </div>
                            <div className="total-projects ms-3">
                              <h6>Dispatch Report </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                )}
                {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                  <div className="col-xl-2 pe-0">
                    <Link
                      to="/dispatch-material"
                      title="This report shows list of the Dispatched Material"
                    >
                      <div className="card box-hover report-box">
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img
                                src={DispatchMaterialImg}
                                width="50"
                                alt=""
                              />
                            </div>
                            <div className="total-projects ms-3">
                              <h6>Dispatch Material </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-xl-2 pe-0">
                  <Link
                    to="/pending-testing"
                    title="Thi report shows list of the approved TC No for which testing is not performed yet"
                  >
                    <div
                      // className="card box-hover"
                      className="card box-hover report-box"
                    >
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <img src={PendingTestingImg} width="50" alt="" />
                          </div>

                          <div className="total-projects ms-3">
                            <h6>Pending Testing </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                {AuthUser?.Permissions?.InternalChat == 1 ? (
                  <div className="col-xl-2 pe-0">
                    <Link
                      to="/chat-history"
                      title="Thi report shows the chat history"
                    >
                      <div
                        // className="card box-hover"
                        className="card box-hover report-box"
                      >
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={ChatHistoryImg} width="50" alt="" />
                            </div>

                            <div className="total-projects ms-3">
                              <h6>Chat History </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-xl-2 pe-0">
                  <Link
                    to="/communication-log"
                    title="This report shows list of the Communication Log"
                  >
                    <div className="card box-hover report-box">
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <img src={CommunicationLogImg} width="50" alt="" />
                          </div>
                          <div className="total-projects ms-3">
                            <h6>Communication Log </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>

                {AuthUser?.Permissions?.MachineMaintenance == 1 ? (
                  <div className="col-xl-2 pe-0">
                    <Link
                      to="/machine-calibration-expiry"
                      title="This report shows list of the Machine Calibration Expire"
                    >
                      <div className="card box-hover report-box">
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calibration} width="50" alt="" />
                            </div>
                            <div className="total-projects ms-3">
                              <h6>Machine Calibration Expiry</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-xl-2 pe-0">
                  <Link
                    to="/testing-raw-data-reports"
                    title="This report shows the Raw Data Log Book and Equipment Log Book"
                  >
                    <div className="card box-hover report-box">
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <img src={LogBookImg} width="50" alt="" />
                          </div>
                          <div className="total-projects ms-3">
                            <h6>Raw Data - Log book</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default Reports;
